import { Component, AfterViewInit } from '@angular/core';
import { OidcService } from '../auth/oidc.service';
import { Log } from 'ng2-logger';

const log = Log.create("OidcAuthenticateComponent");

@Component({
  moduleId: module.id,
  selector: 'oidc-authenticate',
  template: '<p>Logging in...</p>',
})
export class OidcAuthenticateComponent implements AfterViewInit {

  constructor(
    private oidcService: OidcService,
  ) {}

  ngAfterViewInit() {
    log.info("Handling authentication...");

    // oidc-client-ts does NOT like our #, so we get rid of it before parsing
    let newLocation = window.location.href.split("#")[1];
    window.history.replaceState({}, null, newLocation);
    
    this.oidcService.signinCallback().subscribe(() => {
      // Once we process the callback oidc-client-ts will store the user data locally, so
      // we can just redirect to the "frontpage" and let the regular flow handle everything
      // else.
      window.location.href = window.location.origin;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/oidc_authenticate.component.ts